import { render, staticRenderFns } from "./RegionDistrubution.vue?vue&type=template&id=a70f6d82&"
import script from "./RegionDistrubution.vue?vue&type=script&lang=js&"
export * from "./RegionDistrubution.vue?vue&type=script&lang=js&"
import style0 from "./RegionDistrubution.vue?vue&type=style&index=0&id=a70f6d82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports